import { useState } from 'react';
import { TableInput } from '../../../../components/common';

interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
  moduleData: any;
  isView: boolean;
}
const TFoot = ({ preparedBy, approvedBy, moduleData, isView }: Ifoot) => {
  const [render, setRender] = useState(false);

  return (
    <tfoot>
      <tr>
        <th colSpan={2} align="left">
          Prepared By: {preparedBy}
        </th>
        <th colSpan={3} align="left">
          Approved By: {approvedBy}
        </th>
        <th colSpan={2} align="left">
          QA:
          <TableInput
            isView={isView}
            name="qa"
            type="text"
            value={moduleData.qa}
            onChange={(e) => {
              moduleData.qa = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={3} align="left">
          Authorised By (Unit Head):
          <TableInput
            isView={isView}
            name="authorised_by"
            type="text"
            value={moduleData.authorised_by}
            onChange={(e) => {
              moduleData.authorised_by = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
